// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme';
import { TABLET_SMALLER_WIDTH } from 'commons/constants';
import MaterialCard from 'components/MaterialCard/index';

const {
  palette: { greyscale, noodle, blue },
  spacing,
  fontTypes,
  fontColors,
  noodera,
} = getTheme();
export const StyledMaterialCard: StatelessFunctionalComponent<any> = styled(MaterialCard)`
  flex-direction: row;
  padding: ${spacing.x6} ${spacing.x4} ${spacing.x4} ${spacing.x4};
  align-items: center;
  border-left: 8px ${(props) => props.borderColor || blue.noodleBlue} solid;
`;
export const HighlightCardWrapper: StatelessFunctionalComponent<any> = styled.div`
  & > a {
    color: ${fontColors.primary};
  }

  .highlight-card {
    &__content {
      &__wrapper {
        flex: 1;
        align-items: center;
        display: flex;
      }

      &__container {
        flex: 1;
      }
    }

    &__regular-text {
      ${fontTypes.font4};
      display: block;
    }

    &__object {
      margin-right: ${spacing.x4};
      height: 6.4rem;
      width: 6.4rem;
    }

    &__title {
      ${fontTypes.font4};
      font-weight: 700;
      margin-bottom: ${spacing.x6};
      &:last-child {
        margin-bottom: 0;
        margin-top: ${noodera.spacing.x8};
      }
    }

    &__subheading {
      ${fontTypes.font5Semi};
      color: ${greyscale.smoke};
    }

    &__image {
      border-radius: 0.4rem;
      height: 6.4rem;
      width: 6.4rem;
      margin-right: ${spacing.x4};
      object-fit: cover;
    }

    &__school {
      &__indicator {
        ${fontTypes.font5};
        color: ${greyscale.smoke};
      }

      &__acceptance {
        ${fontTypes.font4};
        font-weight: 700;
        display: block;
      }

      &__rating {
        display: flex;
        justify-content: space-between;
      }
    }

    margin-left: -0.7rem;
  }

  .icon-dollar {
    color: ${noodle.secondary};
    font-size: 2.6rem;
    letter-spacing: -${spacing.x5};

    &__container {
      margin-left: -0.7rem;
    }

    &--grey {
      color: ${greyscale.cloud};
    }
  }

  @media only screen and (max-width: ${TABLET_SMALLER_WIDTH}px) {
    .highlight-card {
    }
  }
`;
